import { render } from "./RegisterAboutSection.vue?vue&type=template&id=9d72682e&ts=true"
import script from "./RegisterAboutSection.vue?vue&type=script&lang=ts"
export * from "./RegisterAboutSection.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__